import {Component, CUSTOM_ELEMENTS_SCHEMA, effect, inject, signal, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {
    AccountGridViewEditorComponent
} from '../components/account-grid-view-editor/account-grid-view-editor.component';
import {AppGridViewService} from '../service/app-grid-view.service';
import {NgDynamicComponentsService} from '../service/ng-dynamic-components.service';
import {AdminUserPermissionsComponent} from '../components/admin-user-permissions/admin-user-permissions.component';
import {KeyNamePair} from '../components/app-config-matrix/app-config-matrix.component';
import {AppRoleAndPermissions} from '../security/app-role-and-permissions';

const Offices: KeyNamePair[] = [
    { key: 'ITA', name: 'Italy' },
    { key: 'FRA', name: 'France' },
    { key: 'DEU', name: 'Germany' },
];

const Lobs: KeyNamePair[] = [
    { key: 'AVN', name: 'Aviation' },
    { key: 'FIN', name: 'Finance' },
];

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        AdminUserPermissionsComponent,
    ],
    template: `
        <div class="fullsize-vbox" style="align-items: flex-start; gap: 10px">
            <app-admin-user-permissions [offices]="offices" [lobs]="lobs" [(appRoleAndPermissions)]="appRoles"></app-admin-user-permissions>
        </div>
    `,
    styles: `
    `
})
export class TestUserAdminComponent {

    private readonly editor = viewChild.required<AccountGridViewEditorComponent>('viewEditor');

    private readonly appGridViewSvc = inject(AppGridViewService);
    private readonly dynCompSvc = inject(NgDynamicComponentsService);

    protected readonly offices = Offices;
    protected readonly lobs = Lobs;

    protected appRoles = signal(new AppRoleAndPermissions(['ct_techex']));

    constructor() {
        this.appRoles().setPermission('AVN', 'FRA', true);
        effect(() => {
            console.log('appRoles:', this.appRoles());
        });
    }

    loadTree() {
        const root = this.appGridViewSvc.loadGridLayoutTree();
        console.log(root);
    }

    setFontSize(number: number) {
    }

    async showTreeDlg() {
        await AccountGridViewEditorComponent.showDialog(this.dynCompSvc);
    }

    async showTreeAddItemDlg() {
        await AccountGridViewEditorComponent.showDialog(this.dynCompSvc, {
            input: { mode: 'edit' }
        });
    }
}
